import { useEffect } from 'react';

let hasPolyfilled = false;

// This polyfill is predominantly for iOS Safari versions 12 and under which at the time of writing
// represents around 3% of Zoopla iPhone users. The react-use-gesture library requires
// this API and therefore this polyfill.
// https://caniuse.com/pointer
const usePointerEventPolyfill = () => {
    useEffect(() => {
        const isBrowserMissingPointerEventAPI = !('PointerEvent' in window);

        if (!hasPolyfilled && isBrowserMissingPointerEventAPI) {
            // Prevent the polyfill from being fetched/executed multiple times
            hasPolyfilled = true;

            import('elm-pep');
        }
    }, []);
};

export default usePointerEventPolyfill;
